
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(4(60[78]|163|387)|2([38]57|618|799|88)|6(465|491|524|768|813|971)|1(679|68|875)|8(184|410|624|639|989)|7(251|47|612|641|807)|3((0|61|77)1|234|320)|9([67]32|251|579|585))$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
